import { useState } from "react";
import TopicSelection from "./TopicSelection";
import ChevronIcon from "./ChevronIcon";

const Dropdown = ({ header, selections }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="dropdown">
      <div onClick={() => setExpanded(!expanded)} className="dropdown-header">
        <ChevronIcon expanded={expanded} />
        <h5 className={expanded ? "dropdown-header-text-selected" : "dropdown-header-text"}>{header}</h5>
      </div>
      {expanded && selections && selections.map((selection, index) => <TopicSelection key={index} selection={selection} />)}
    </div>
  );
};

export default Dropdown;
